import React from 'react';

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useForm } from '../../../../shared/hooks/form-hook';
import Input from '../../../../shared/components/FormElements/input';
import { VALIDATOR_REQUIRE } from '../../../../shared/util/validators';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ImageUpload from '../../../../shared/components/FormElements/imageUpload';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './addCourse.css'


const AddCourse = () => {

  const history = useHistory();

    const [formState, inputHandler  ] = useForm(
        {
            title: {
              value: '',
              isValid: false
            },
            who: {
                value: '',
                isValid: false
              },
            day: {
              value: '',
              isValid: false
            },
            date: {
              value: '',
              isValid: false
            },
            time: {
                value: '',
                isValid: false
              },
            image: {
                value: null,
                isValid: false
            },
            location: {
                value: '',
                isValid: false
              },
            createdAt: {
              value: '',
              isValid: false
            }
        },
        false
    );

 
   

    const addHandler = async (event) => {
        event.preventDefault();

        try {
          const formData = new FormData();
          formData.append('title', formState.inputs.title.value);
          formData.append('intro', formState.inputs.intro.value);
          formData.append('who', formState.inputs.who.value);
          formData.append('day', formState.inputs.day.value);
          formData.append('time', formState.inputs.time.value);
          formData.append('date', formState.inputs.date.value);
          formData.append('location', formState.inputs.location.value);
          formData.append('image', formState.inputs.image.value);
         

          const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/course', {
            method: 'POST',
            body: formData
          });
         
        
        const responseData = await response.json();
        console.log(responseData)
          history.push('/');
        } catch (err) {
          console.log(err)
        }
        // window.success('Successfully');
    }

    return (  
        <main className='news-container'> 
          <Link to='/'><FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce'/></Link>
            <h1>Шинэ зар нэмэх</h1>  
          
            <div className='news-form-container'> 
            
            <form onSubmit={addHandler} className='news-form'>
                <Input 
                  element="input" 
                  id="title" 
                  type="text" 
                  label="Айлдварын нэр"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                
                <Input 
                  element="textarea"
                  id="intro" 
                  type="text" 
                  label="Товч танилцуулга"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a your article' 
                  onInput={inputHandler}
                />
                <Input 
                  element="input" 
                  id="who" 
                  type="text" 
                  label="Айлдагчийн нэр"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                
                <ImageUpload 
                  id='image'
                  onInput={inputHandler}
                />
                <Input 
                  element="input" 
                  id="day" 
                  type="text" 
                  label="Гарaг"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                <Input 
                  element="input" 
                  id="date" 
                  type="text" 
                  label="Огноо"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                <Input 
                  element="input" 
                  id="time" 
                  type="text" 
                  label="Цаг"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                <Input 
                  element="input" 
                  id="location" 
                  type="text" 
                  label="Хаана"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />

                <Button type="submit" disabled={!formState.isValid} variant='contained' style={{marginTop: '20px'}}>Publish</Button>
            </form>
            </div> 
        </main>  
    )
}

export default AddCourse;